import React from 'react';
//import DOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { UserRoles, EditState } from '../shared/enums';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import "./Home.css";

class SpecialsList extends React.Component {
    displayName = SpecialsList.name;

    render() {
        var items = this.props.items.map((item, index) => {
            return (
                <SpecialsListItem editMode={this.props.editMode} key={index} index={index} item={item}
                    onChangeFile={this.props.onChangeFile} onRemoveItem={this.props.onRemoveItem}
                    onChangeHeader={this.props.onChangeHeader} onChangeText={this.props.onChangeText}
                    isCopyHome={this.props.isCopyHome} toggleAddToCopyHome={this.props.toggleAddToCopyHome}
                    setIsChecked={this.props.setIsChecked}
                />
            );
        });
        return (
            <ul className="list-group">{items}</ul>
        );
    }
}

class SpecialsListItem extends React.Component {
    displayName = SpecialsListItem.name;
    blankImage = 'R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    render() {
        return (
            <div>
                {this.props.editMode === EditState.Edit &&
                    <li className="list-group-item">
                        <Row>
                            <Col xs={3}>
                                <button style={{ border: '1px solid lightgray', backgroundColor: 'transparent' }} title="Click to upload image" onClick={() => { this.upload.click(); }} >
                                    <img src={"data: image/jpeg;base64," + (this.props.item.imageData || this.blankImage)} alt=""
                                        className="img-special-edit" title="Click image to change it"
                                    />
                                    <input type="file" style={{ display: 'none' }} ref={(ref) => this.upload = ref}
                                        onChange={(e) => this.props.onChangeFile(this.props.index, e)}
                                    />
                                </button>
                            </Col>
                            <Col xs={8} style={{ paddingLeft: '0px' }}>
                                <input type="text" className="form-control HomeItemInput" value={this.props.item.header} placeholder="Enter Heading"
                                    onChange={(e) => this.props.onChangeHeader(this.props.index, e)}
                                />
                                <input type="text" className="form-control HomeItemInput" value={this.props.item.text} placeholder="Enter Details"
                                    onChange={(e) => this.props.onChangeText(this.props.index, e)}
                                />
                            </Col>
                            <Col sm={1}><button className="pull-right btn btn-outline-danger btn-sm deleteButton" onClick={(e) => this.props.onRemoveItem(this.props.index, e)} >X</button></Col>
                        </Row>
                    </li>
                }
                {this.props.editMode === EditState.List &&
                    <li className="list-group-item" style={{ border: 'none' }}>
                        <Row>
                            <Col xs={3}>
                                {this.props.item.imageData !== null &&
                                    <img src={"data: image/jpeg;base64," + this.props.item.imageData} alt="" className="img-special" />
                                }
                            </Col>
                            <Col xs={9}>
                                <Row className="home-item home-special-header">
                                {this.props.item.header}
                                    {this.props.isCopyHome &&
                                        <div style={{ float: 'right' }}>
                                            <label htmlFor="test" />
                                            <label className="homeCheckbox">
                                        <input type="checkbox" name="test" checked={this.props.item.isChecked} onChange={(e) => this.props.setIsChecked(this.props.item)}/>
                                                <span />
                                            </label>
                                        </div>
                                    }
                                </Row>
                                <Row className="home-item home-special-detail">
                                    {this.props.item.text}
                                </Row>
                            </Col>
                        </Row>
                    </li>
                }
            </div>
        );
    }
}

class SpecialsHeader extends React.Component {
    displayName = SpecialsHeader.name;

    render() {
        return (
            <div className="ogcText">
                <div style={{ display: 'inline-block', marginLeft: '2%', marginTop: '10px', fontSize: 'larger' }}>
                    <span className="homeHeader">OGC SPECIALS</span>
                </div>
                {!this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        {this.props.showEditForm && this.props.editMode === EditState.List &&
                            <button className="ogcButton btn-std-size" onClick={this.props.onClickEdit}>Edit</button>
                        }
                        {this.props.showEditForm && this.props.editMode === EditState.Edit &&
                            <React.Fragment>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClickAdd}>Add</button>
                                <button className={(this.props.isDirty) ? "ogcButton btn-std-size" : "ogcDisabledButton btn-std-size"} onClick={this.props.onClickSubmit} disabled={!this.props.isDirty}>Submit</button>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClearItems}>Clear All</button>
                                <button className="ogcButton ogcButton-brown btn-std-size" onClick={this.props.onClickCancel}>Cancel</button>
                            </React.Fragment>
                        }
                    </div>
                }
                {this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickSelectAll}>Select All</button>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickUnselectAll}>Unselect All</button>
                    </div>
                }
            </div>
        );
    }
}

class Specials extends React.Component {
    displayName = Specials.name;

    constructor(props) {
        super(props);

        this.responseStatus = 200;
        this.showEditForm = this.props.isAuthenticated && this.props.isEditHome &&
            (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep);

        this.state = {
            originalSpecials: [],
            specials: [],
            editMode: EditState.List
        };
    }

    componentDidMount = async () => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        const response = await fetch('api/Home/Specials/', fetchConfig);
        if (response.ok) {
            let data = await response.json();

            var special = data;

            special.map((obj) => {
                obj.isChecked = false;
                return obj;
            });

            this.setState({ specials: special });
        }
        else if (response.status === 401) {
            this.props.signOut();
        }
        else {
            var err = await response.text();
            console.log(`Failed to load Specials: ${err}.`);
            toast.error("Failed to load Specials.");
        }
    };

    onRemoveItem = (idx, e) => {
        var items = this.state.specials;
        items.splice(idx, 1);
        this.setState({ specials: items });
        this.props.setDirty(true);
    }

    onClearItems = () => {
        this.setState({ specials: [] });
        this.props.setDirty(true);
    }

    onChangeHeader = (idx, e) => {
        let items = this.state.specials;
        items[idx].header = e.target.value;
        this.setState({ specials: items });
        this.props.setDirty(true);
    }

    onChangeText = (idx, e) => {
        let items = this.state.specials;
        items[idx].text = e.target.value;
        this.setState({ specials: items });
        this.props.setDirty(true);
    }

    onChangeFile = (idx, e) => {
        let items = this.state.specials;
        var reader = new FileReader();
        reader.addEventListener("load", () => {
            items[idx].imageData = reader.result.split(',')[1];
            this.setState({ specials: items });
            this.props.setDirty(true);
        }, false);
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    onClickSubmit = async () => {
        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(this.state.specials)
        };

        // This could take a while
        toast.warn('Saving Specials. Please wait...', { autoClose: 50000, hideProgressBar: false });

        const response = await fetch('api/Home/Specials/', fetchConfig);
        toast.dismiss();
        if (response.ok) {
            toast.success("Specials updated.");
            this.setState({ editMode: EditState.List });
            this.props.setDirty(false);
        }
        else if (response.status === 401) {
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.error(`Error saving Specials.`);
            console.log(`Error saving Specials: ${await response.text()}.`);
        }
    }

    onClickEdit = (e) => {
        const deepCopy = this.state.specials.map(a => Object.assign({}, a));
        this.setState({ editMode: EditState.Edit, originalSpecials: deepCopy });
    }

    onClickCancel = (e) => {
        this.setState({ editMode: EditState.List, specials: this.state.originalSpecials });
        this.props.setDirty(false);
    }

    onClickAdd = (e) => {
        var items = this.state.specials;
        items.push({
            index: this.state.specials.length + 1,
            imageData: null,
            header: '',
            text: ''
        });
        this.setState({ editMode: EditState.Edit, specials: items });
        this.props.setDirty(true);
    }

    setIsChecked = async (item) => {
        var special = item;
        special.isChecked = !special.isChecked;

        await this.setState({ item });

        var specials = this.state.specials.filter(function (n) { return n.isChecked; });

        this.props.toggleAddToCopyHome('specials', specials);
    }

    onClickSelectAll = async () => {
        var specials = this.state.specials;

        specials.map((obj) => {
            obj.isChecked = true;
            return obj;
        });

        await this.setState({ specials });
        this.props.toggleAddToCopyHome('specials', specials);
    }

    onClickUnselectAll = async () => {
        var specials = this.state.specials;

        specials.map((obj) => {
            obj.isChecked = false;
            return obj;
        });

        await this.setState({ specials });
        this.props.toggleAddToCopyHome('specials', []);
    }

    render() {
        return (
            <div>
                <SpecialsHeader
                    editMode={this.state.editMode}
                    showEditForm={this.showEditForm}
                    onClickEdit={this.onClickEdit}
                    onClickCancel={this.onClickCancel}
                    onClickAdd={this.onClickAdd}
                    onClickSubmit={this.onClickSubmit}
                    isCopyHome={this.props.isCopyHome}
                    onClearItems={this.onClearItems}
                    onClickSelectAll={this.onClickSelectAll}
                    onClickUnselectAll={this.onClickUnselectAll}
                    isDirty={this.props.isDirty}
                />
                <div className="home-specials">
                    <SpecialsList
                        onChangeFile={this.onChangeFile}
                        items={this.state.specials}
                        onRemoveItem={this.onRemoveItem}
                        editMode={this.props.isCopyHome === true ? EditState.List : this.state.editMode}
                        onChangeHeader={this.onChangeHeader}
                        onChangeText={this.onChangeText}
                        isCopyHome={this.props.isCopyHome}
                        setIsChecked={this.setIsChecked}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Specials));


// WEBPACK FOOTER //
// ./src/components/Home/Specials.js